// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__L7TRz","topBottomGutter":"Layout_topBottomGutter__1RXJJ"};